/* fb-home.js — FurrBites homepage behaviour. Load with defer. */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- 1. Scroll progress bar ------------------------------------------ */
  function progress() {
    var bar = document.getElementById('fb-progress');
    if (!bar) return;
    var ticking = false;
    function paint() {
      var h = document.documentElement.scrollHeight - window.innerHeight;
      bar.style.width = (h > 0 ? (window.scrollY / h) * 100 : 0) + '%';
      ticking = false;
    }
    function onScroll() { if (!ticking) { requestAnimationFrame(paint); ticking = true; } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    paint();
  }

  /* ---- 2. Marquee: duplicate content so translateX(-50%) loops seamlessly
       Done in JS rather than Liquid so a merchant can add or remove items in
       the theme editor without the loop breaking.                          */
  function marquees() {
    document.querySelectorAll('[data-fb-marquee]').forEach(function (track) {
      if (track.dataset.fbCloned === 'true') return;
      var original = track.innerHTML;
      track.innerHTML = original + original;
      track.dataset.fbCloned = 'true';
    });
  }

  /* ---- 3. Reveal on scroll --------------------------------------------- */
  function reveals() {
    var els = document.querySelectorAll('.fb-rv');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('fb-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('fb-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    els.forEach(function (el) { io.observe(el); });
  }

  function init() { progress(); marquees(); reveals(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }

  /* Re-run when a section is re-rendered inside the theme editor. */
  document.addEventListener('shopify:section:load', function () { marquees(); reveals(); });
})();
